export default "__VITE_ASSET__tTyQylZd__"